import { useTranslations } from '@vocab/react';
import translations from './.vocab';
import {
  Box,
  Card,
  Columns,
  Column,
  Stack,
  ButtonIcon,
  IconEdit,
  Text,
  Drawer,
} from 'braid-design-system';
import { useState } from 'react';
import { LoadingItem } from 'src/components/LoadingItem/LoadingItem';
import { EditSharedProfileSettings } from './EditSharedProfileSettings';
import { useGetSharedProfileVisibility } from 'src/modules/graphql/visibility/data';
import { useAnalytics } from 'src/contexts/AnalyticsContext';
import { useTypedSelector } from 'src/reducers';
import { PageTitles } from 'src/components/Notifications/pageTitle';

export const SharedProfile = () => {
  const brand = useTypedSelector((state) => state.page.pageAnalytics.brand);
  const { t } = useTranslations(translations);
  const [drawerOpened, setDrawerOpened] = useState(false);
  const { trackProfileCardOpened } = useAnalytics();

  const toggle = () => {
    if (drawerOpened === false) {
      trackProfileCardOpened({ currentPageSubsection: 'shared profile' });
    }
    setDrawerOpened((currentState) => !currentState);
  };

  const { isShareableProfileActive, shareableProfileUrl, loading, error } =
    useGetSharedProfileVisibility();

  const sharedProfileStatusLabel = () => {
    if (Boolean(shareableProfileUrl)) {
      return isShareableProfileActive ? t('On') : t('Off');
    }
    return t('Link not created');
  };

  return (
    <Box data-testid="shared-profile-card">
      <Card rounded>
        <Columns space="small">
          <Column>
            <Stack space="medium">
              <Text weight="strong">
                {t('Share BRAND profile', { brand: PageTitles[brand] })}
              </Text>
              {loading || error ? (
                <LoadingItem size="standard" width="small" />
              ) : (
                <Text tone="secondary">{sharedProfileStatusLabel()}</Text>
              )}
            </Stack>
          </Column>
          <Column width="content">
            <ButtonIcon
              id="editSharedProfileButton"
              variant="transparent"
              icon={<IconEdit />}
              label={t('Edit visibility')}
              onClick={toggle}
            />
          </Column>
        </Columns>
      </Card>
      <Drawer
        id="sharedProfileDrawer"
        title={t('Share BRAND profile', { brand: PageTitles[brand] })}
        open={drawerOpened === true}
        onClose={toggle}
        width="small"
      >
        <EditSharedProfileSettings />
      </Drawer>
    </Box>
  );
};
